export interface IHomeHighlight {
  icon: string;
  text: string;
  requiresGenerationalFunds?: boolean;
}

export interface IHomeBenefit {
  title: string;
  text: string;
}

export const HOME_GREETING = {
  title: 'Ahorra hoy y vive mejor mañana con una Cuenta APV',
  subtitle:
    'Complementa tu pensión con el Ahorro Previsional Voluntario y accede a beneficios estatales o tributarios dependiendo del Régimen que elijas.',
  button: 'Suscribir APV',
};

export const HOME_HIGHLIGHTS: IHomeHighlight[] = [
  { icon: 'icons/savings.svg', text: 'Mejora tu pensión ahorrando desde hoy' },
  { icon: 'icons/monitoring.svg', text: 'Comisión de solo\n0,51% anual' },
  {
    icon: 'icons/price-check.svg',
    text: 'Elige tu Fondo Generacional',
    requiresGenerationalFunds: true,
  },
  { icon: 'icons/money-bag.svg', text: 'Retiro flexible cuando\nlo necesites' },
];

export const HOME_ASSETS = {
  videoCover: 'home/video-apv.webp',
  ctaBanner: 'home/banner-apv.webp',
  playIcon: 'icons/play-circle-fill.svg',
  externalIcon: 'icons/open-in-new.svg',
};

export const HOME_VIDEO = {
  tag: 'Te explicamos en simple',
  title: '¿Cómo funciona tu APV?',
  text: 'Revisa en 1 minuto cómo definir tu monto, tu régimen tributario y tu Fondo Generacional.',
  play: 'Reproducir el video',
};

export const HOME_BENEFITS_TITLE = 'Beneficios de tener un APV';
export const HOME_BENEFITS_BUTTON = 'Conoce más';

export const HOME_BENEFITS: IHomeBenefit[] = [
  {
    title: 'Elige tu régimen tributario',
    text: 'Según el régimen que elijas, puedes pagar menos impuestos o recibir una bonificación estatal del 15% de tu ahorro.',
  },
  {
    title: 'Mejora tu pensión',
    text: 'La rentabilidad de tu ahorro te ayuda a tener una mejor pensión.',
  },
  {
    title: 'Suscribe sin costo',
    text: 'Comenzar a aportar en APV es gratuito y 100% online.',
  },
  {
    title: 'Ahorra a tu ritmo',
    text: 'Modifica cuando quieras el monto y la frecuencia de tu ahorro. Además, puedes girar tu dinero cuando lo necesites.',
  },
];

export const HOME_CTA = {
  title: 'Empieza a ahorrar para tu pensión',
  text: 'En simples pasos: solo define tu monto, régimen y fondo.',
  button: 'Suscribir APV',
};

export const HOME_SUBSCRIPTION_URL = '../suscripcion/paso/1';

export const HOME_LINKS = {
  video: 'https://www.youtube.com/watch?v=1vUherxYRyM',
  benefits: 'https://www.afpcapital.cl/ahorro-voluntario/apv',
};
